import { FC, ReactNode } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from 'components/accordion/accordion';
import styles from './page.module.scss';

// Collapsible titled section, shared by the run-detail and agent-config panels.
export const Section: FC<{
  title: string;
  defaultExpanded?: boolean;
  children: ReactNode;
}> = ({ title, defaultExpanded = false, children }) => (
  <Accordion className={styles.section} defaultExpanded={defaultExpanded}>
    <AccordionSummary className={styles.sectionTitle}>{title}</AccordionSummary>
    <AccordionDetails>
      <div className={styles.sectionDetails}>{children}</div>
    </AccordionDetails>
  </Accordion>
);
